import { createSlice } from "@reduxjs/toolkit";
import { fetchAccountHistory, fetchAllOrders, fetchAllPositions, fetchAllSLTP } from "../thunks/orders";

const orderPositionSlice = createSlice({
  name: "orderPosition",
  initialState: {
    orders: [],
    positions: [],
    accountHistory: [],
    orderSLTP: [],
    amountForOneClick: null,
  },
  reducers: {
    setOrdersData: (state, action) => {
      state.orders = action.payload;
    },
    addOrdersData: (state, action) => {
      state.orders.push(action.payload);
    },
    updateOrdersData: (state, action) => {
      const index = state.orders.findIndex(orders => orders?.id === action.payload?.id);
      if (index !== -1) {
        state.orders[index] = action.payload;
      }
    },
    deleteOrdersData: (state, action) => {
      state.orders = state.orders.filter(orders => orders?.id !== action.payload);
    },
    setPositionsData: (state, action) => {
      state.positions = action.payload;
    },
    updatePositionData: (state, action) => {
      const index = state.orderSLTP.findIndex(sltp => sltp.positionId === action.payload?.id);
      if (index !== -1) {
        state.orderSLTP[index] = action.payload;
      }
      const indexposition = state.positions.findIndex(position => position.id === action.payload?.id);
      if (indexposition !== -1) {
        state.positions[indexposition] = action.payload;
      }
    },
    addPositionsData: (state, action) => {
      state.positions.push(action.payload);
    },
    deletePositionsData: (state, action) => {
      state.positions = state.positions.filter(positions => positions?.id !== action.payload);
    },
    setAccountHistoryData: (state, action) => {
      state.accountHistory = action.payload;
    },
    addAccountHistoryData: (state, action) => {
      console.log(state.accountHistory)
      state.accountHistory.push(action.payload);
    },
    setOrderSLTP: (state, action) => {
      state.orderSLTP = action.payload;
    },
    editSLTPOrder: (state, action) => {
      state.orderSLTP = state.orderSLTP.map((sltp) =>
        sltp.id === action.payload?.id ? action.payload : sltp
      );
    },
    addSLTPOrder: (state, action) => {
      state.orderSLTP.push(action.payload);
    },

    deleteSLTPOrder: (state, action) => {
      state.orderSLTP = state.orderSLTP.filter((sltp) => sltp?.id !== action.payload);
    },
    setAmountForOneClick: (state, action) => {
      state.amountForOneClick = action.payload;
    }

  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllOrders.fulfilled, (state, action) => {
      state.orders = action.payload
    })
      .addCase(fetchAccountHistory.fulfilled, (state, action) => {
        state.accountHistory = action.payload;
      })
      .addCase(fetchAllPositions.fulfilled, (state, action) => {
        state.positions = action.payload
      })
      .addCase(fetchAllSLTP.fulfilled, (state, action) => {
        state.orderSLTP = action.payload
      })
  },

});
export const { setAccountHistoryData, setPositionsData, addOrdersData, setOrdersData, deleteOrdersData, deletePositionsData, addPositionsData, updateOrdersData, updatePositionData, setOrderSLTP, deleteSLTPOrder, editSLTPOrder, addSLTPOrder, setAmountForOneClick, addAccountHistoryData } = orderPositionSlice.actions;
export default orderPositionSlice.reducer;
